const NavFooter = (): JSX.Element => {
  const date = new Date()
  return (
    <div className="navigation-sideBar-footer-container">
      <div className="navigation-sideBar-footer">{`©${date.getFullYear()} Powered By Specialist Direct`}</div>
    </div>
  )
}

export default NavFooter
